import React, { useEffect, useState } from "react"
import { Box, Button, FormHelperText, Stack, TextField, Typography } from "@mui/material"
import { COLORS } from "../../utils"

const sx = {
  card: {
    // padding: "16px 16px 40px 16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "16px",
    alignItems: "center",
    gap: "40px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    border: "1px solid #DBDBDB",
    background: "#FFF",
    alignSelf: "stretch",
  },
  title: {
    color: "#262626",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "28px",
  },
  description: {
    color: "#414141",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    "& span": {
      fontWeight: 500,
    }
  },
  input: {
    "& .MuiInputBase-input": {
      fontWeight: "normal",
      fontSize: 60,
      lineHeight: 1,
      color: COLORS.BLACK_CARD,
      textAlign: "center",
      width: 126,
      height: 68,
      padding: 0,
    },
    "& ::before": {
      marginTop: 0,
    },
    "&.is-tablet": {
      marginTop: 29,
    },
  },
  errorText: {
    fontSize: "16px",
    color: COLORS.RED_700,
    lineHeight: 1.5,
  },
  validateButton: {
    width: 448,
    height: 72,
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "1.25px",
    "&:hover, &:disabled, &:disabled:hover": {
      color: COLORS.WHITE,
      backgroundColor: COLORS.PRIMARY_COLOR,
    },
  },
  confirmationButton: {
    backgroundColor: COLORS.ORANGE_AMBER_900,
    color: COLORS.WHITE,
    "&:hover, &:disabled, &:disabled:hover": {
      color: COLORS.WHITE,
      backgroundColor: COLORS.ORANGE_AMBER_900,
      opacity: 0.8
    },
  }
}

const InputCardNumberWithRetail = ({
  selectedCard,
  isTablet,
  onSubmit,
  onChangeInput,
  initialValues,
  availableVolume = 0,
  isConfirmation = false
}) => {
  const [values, setValues] = useState({
    foodcheri: "",
    fridgeRetail: ""
  })

  const [errors, setErrors] = useState({
    foodcheri: "",
    fridgeRetail: ""
  })

  useEffect(() => {
    if (!initialValues) return

    setValues(initialValues)
  }, [initialValues])
  const handleChange = (e) => {
    const newValues = {
      ...values,
      [e.target.name]: e.target.value
    }

    setValues(newValues)
    onChangeInput(newValues)

    if (e.target.name === "fridgeRetail" && Number(e.target.value) > availableVolume) {
      setErrors({
        ...errors,
        fridgeRetail: `Le nombre saisi est supérieur au nombre de produits encore disponibles (${availableVolume}).`
      })

      return
    }

    setErrors({
      ...errors,
      [e.target.name]: ""
    })
  }

  const isPackaged = selectedCard.packagingNumber > 1 && selectedCard.packagingNumberUnit === "piece"

  const handleSubmit = (e) => {
    e.preventDefault()
    // Treat empty values as 0
    const submittedValues = {
      foodcheri: values.foodcheri === "" ? "0" : values.foodcheri,
      fridgeRetail: values.fridgeRetail === "" ? "0" : values.fridgeRetail
    }
    onSubmit(submittedValues)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={4} alignItems="center" sx={{ marginTop: "32px" }}>
        {[
          {
            id: "retail",
            name: "fridgeRetail",
            logo: "/icons/Fridge-retail-square-logo.svg",
            title: "Frigo de retail",
          },
          {
            id: "fc",
            name: "foodcheri",
            logo: "/icons/FC-square-logo.svg",
            title: "Stock FoodChéri",
          },
        ].map((item, index) => (
          <Box
            sx={{
              ...sx.card,
              paddingBottom: errors[item.name] ? "16px" : "40px",
              ...(errors[item.name] ? { borderColor: COLORS.RED_700 } : {})
            }}
            key={item.id + index}
          >
            {/* Top */}
            <Stack direction="row" spacing={2}>
              <img
                src={item.logo}
                alt={item.id + "-logo"}
              />
              <Stack spacing={1} alignItems="flex-start">
                <Typography variant="h6" sx={sx.title}>
                  {item.title}
                </Typography>
                {isConfirmation
                  ? (
                    <Typography sx={sx.description}>
                      Recomptez la quantité de <span>{selectedCard.uniqueCode}</span> reçue 🙏
                    </Typography>
                  ) : (
                    <Typography sx={sx.description}>
                      Entrez le total de <span>{selectedCard.uniqueCode}</span> conformes reçues
                    </Typography>
                  )}
              </Stack>
            </Stack>
            {/* Bottom */}
            <div>
              <TextField
                name={item.name}
                variant="standard"
                inputProps={{
                  className: isTablet ? "is-tablet " : "",
                  placeholder: "000",
                  inputMode: "numeric",
                  pattern: "[0-9]*"
                }}
                onChange={handleChange}
                // inputRef={inputRef}
                value={values[item.name]}
                sx={sx.input}
              />
            </div>
            {isPackaged && (
              <div>
                📦 <b>Attendu : {selectedCard.initialVolume / selectedCard.packagingNumber} boîtes</b> (soit {selectedCard.initialVolume} pièces) Merci de saisir le nombre de <b>pièces</b>.
              </div>
            )}
            {errors[item.name] && (
              <div>
                <FormHelperText error sx={sx.errorText}>
                  {errors[item.name]}
                </FormHelperText>
              </div>
            )}
          </Box>
        ))}
        {/* button submit */}
        <Button
          className={isTablet ? "is-tablet " : ""}
          sx={{ ...sx.validateButton, ...(isConfirmation ? sx.confirmationButton : {}) }}
          variant="contained"
          color="primary"
          disableElevation
          disabled={errors.fridgeRetail !== ""}
          type="submit"
        >
          Confirmer
        </Button>
      </Stack>
    </form>
  )
}

export default InputCardNumberWithRetail
